<div class="breadcrumb-container" #containerRef>
  <ng-container *ngFor="let segment of segments; let i = index">
    <span *ngIf="i < visibleCount" #crumbRef class="breadcrumb-segment">{{ capitalizeFirstLetter(segment) }}</span>
    <lucide-icon
      *ngIf="hiddenFlag ? i < visibleCount - 1 : i < visibleCount - 1 && segment !== segments[segments.length - 1]"
      name="chevron-right"
      class="breadcrumb-separator">
    </lucide-icon>
  </ng-container>
</div>
